const backgrounds = ['brandLight', 'grey', 'white', 'whiteWithBorder'];

// Custom headline sizes for Image Hero V3 = xsmall, small, medium, large for different viewports xxs (mobile), m (tablet), l (desktop)
const headlineSizesV3 = {
	xsmall: {
		// Viewport sizes
		xxs: '2',
		m: '2',
		l: '4',
	},
	small: {
		// Viewport sizes
		xxs: '3',
		m: '3',
		l: '6',
	},
	medium: {
		// Viewport sizes
		xxs: '4',
		m: '4',
		l: '8',
	},
	large: {
		// Viewport sizes
		xxs: '5',
		m: '5',
		l: '10',
	},
};

const variants = {
	v2: 'v2',
	v3: 'v3',
};

const componentConfig = {
	typography: {
		size: {
			headline: {
				xxs: { [variants.v2]: '2', [variants.v3]: '2' },
				m: { [variants.v2]: '4', [variants.v3]: '2' },
				l: { [variants.v2]: '8', [variants.v3]: '10' },
			},
			subHeadline: {
				xxs: { [variants.v2]: 'm1', [variants.v3]: 'm1' },
				m: { [variants.v2]: '1', [variants.v3]: 'm1' },
				l: { [variants.v2]: '4', [variants.v3]: '2' },
			},
			description: {
				xxs: { [variants.v2]: 'm1', [variants.v3]: 'm1' },
				l: { [variants.v2]: '2', [variants.v3]: '1' },
			},
			representative: {
				xxs: { [variants.v2]: 'm1', [variants.v3]: '2' },
				m: { [variants.v2]: 'm1', [variants.v3]: '2' },
				l: { [variants.v2]: '3', [variants.v3]: '4' },
			},
			terms: { xxs: { [variants.v2]: 'm2', [variants.v3]: 'm2' } },
		},
		type: {
			headline: 'display',
			subHeadline: 'heading',
			description: 'paragraph',
			representative: 'heading',
			terms: 'paragraph',
		},
	},
};

const styledComponentConfig = {
	contentWrapper: {
		gap: {
			xxs: {
				[variants.v2]: 'var(--spacing-global-space5)', // 16px
				[variants.v3]: 'var(--spacing-global-space5)', // 16px
			},
			m: {
				[variants.v2]: 'var(--spacing-global-space6)', // 24px
				[variants.v3]: 'var(--spacing-global-space3)', // 8px
			},
			l: {
				[variants.v2]: 'var(--spacing-global-space7)', // 32px
				[variants.v3]: 'var(--spacing-global-space5)', // 16px
			},
		},
		padding: {
			xxs: {
				[variants.v2]: 'var(--spacing-global-space5)', // 16px
				[variants.v3]: 'var(--spacing-global-space3)', // 8px
			},
			m: {
				[variants.v2]: {
					// Left and right keys below represent image positions. Padding values are the same regardless of image position for v2
					left: '0 var(--spacing-global-space9)', // 24px 48px
					right: '0 var(--spacing-global-space9)', // 24px 48px
				},
				[variants.v3]: {
					// Left and right keys below represent image position. Padding left and right change based on image position for v3
					left: 'var(--spacing-global-space1) var(--spacing-global-space9) var(--spacing-global-space1) var(--spacing-global-space5)', // 2px 48px 2px 16px
					right:
						'var(--spacing-global-space1) var(--spacing-global-space5) var(--spacing-global-space1) var(--spacing-global-space9)', // 2px 16px 2px 48px
				},
			},
			l: {
				[variants.v2]: 'var(--spacing-global-space1) var(--spacing-global-space10)', // 2px 64px
				[variants.v3]:
					'var(--spacing-global-space1) var(--spacing-global-space7) var(--spacing-global-space1) var(--spacing-global-space9)', // 2px 32px 2px 48px'
			},
		},
	},
	imageHero: {
		backgroundColor: {
			brandLight: 'var(--color-brand-light)', // --color-very-pink100 or --color-littlewoods-purple100
			grey: 'var(--color-functional-panelMid)', // #FAFAFA
			white: 'var(--color-functional-panelLight)', // #000000
			whiteWithBorder: 'var(--color-functional-panelLight)', // #000000
		},
		border: {
			brandLight: 'none',
			grey: 'none', // #FAFAFA
			white: 'none', // #000000
			whiteWithBorder: 'var(--border-width-xs) solid var(--color-brand-mid)', // 1px solid --color-very-pink500 or --color-littlewoods-purple500
		},
	},
	imageWrapper: {
		width: {
			xxs: {
				[variants.v2]: '100%',
				[variants.v3]: '100%',
			},
			m: {
				[variants.v2]: {
					'1:1': 'calc(311/720 * 100%)', // Width calculated based on figma design due to absent of ratio / percentage to container
					'4:3': 'calc(416/720 * 100%)', // Width calculated based on figma design due to absent of ratio / percentage to container
				},
				[variants.v3]: 'calc(256/720 * 100%)', // Width calculated based on figma design due to absent of ratio / percentage to container
			},
			l: {
				[variants.v2]: {
					'1:1': 'calc(555/1280 * 100%)', // Width calculated based on figma design due to absent of ratio / percentage to container
					'4:3': 'calc(740/1280 * 100%)', // Width calculated based on figma design due to absent of ratio / percentage to container
				},
				[variants.v3]: 'calc(334/1280 * 100%)', // Width calculated based on figma design due to absent of ratio / percentage to container
			},
		},
		alignItems: {
			[variants.v2]: 'normal',
			[variants.v3]: 'center',
		},
		displayMobile: {
			[variants.v2]: 'block',
			[variants.v3]: 'flex',
		},
	},
};

export { backgrounds, componentConfig, headlineSizesV3, styledComponentConfig, variants };
